import { makeStyles } from '@material-ui/core/styles'
import { grey } from "@material-ui/core/colors";

const appStyle = makeStyles(theme => ({
  root: {
    flex: 1
  },
  ref: {
    display: 'flex',
    minHeight: '100vh',
    flex: 1
  },

  themeParent: {
    color: '#000',
    height: '100vh',
    width: '100vw',
  },
  themeRight: {
    position: 'fixed',
    top: 0,
    right: 0,
    height: '100vh',
    width: '70%',
    backgroundColor: '#242424',//'#222222', //'#1E415A', // #52576D'
    //flex: 0.7,
    order: 1
  },
  themeLeft: {
    width: '30%',
    backgroundColor: grey[700],
    //flex: 0.3
  },
}));

export default appStyle;
